<template>
  <div :class="`element element__icon ${nameToClasses(name,'element__icon')}`">
    <svg v-if="animated" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="animation">
      <g class="animation__wrapper animation__wrapper--base" animation-state="on">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
        <rect class="animation__wrapper__fill" width="100" height="100"></rect>
      </g>

      <g class="animation__wrapper animation__wrapper--layer1" animation-state="on">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
      </g>

      <g class="animation__wrapper animation__wrapper--layer2" animation-state="on">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
      </g>

      <g class="animation__wrapper animation__wrapper--base" animation-state="off">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
        <rect class="animation__wrapper__fill" width="100" height="100"></rect>
      </g>

      <g class="animation__wrapper animation__wrapper--layer1" animation-state="off">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
      </g>

      <g class="animation__wrapper animation__wrapper--layer2" animation-state="off">
        <rect class="animation__wrapper__border" width="100" height="100"></rect>
      </g>
    </svg>
  </div>
</template>

<script>
/**/
export default {
	props: {
		name: String,
		animated: Boolean,
	},
	methods: {
		nameToClasses(name, baseClass) {
			// Transform name to bem style classes for every -- depth one class
			return typeof name !== 'undefined' && name.split
				? name.split('--').reduce(
						(acc, name) => {
							acc.nameParts.push(name);
							acc.classes = `${acc.classes} ${baseClass}--${acc.nameParts.join('--')}`;
							return acc;
						},
						{ classes: '', nameParts: [] }
				  ).classes
				: name;
		},
	},
};
</script>

<style lang="scss">
</style>
